export default {
  name: 'Set Of Cards Infinite',
  htmlId: 'setOfCardsInfinite',
};
